/* Tidy Towel (Oct 2026): auto-scrolling reviews row. Native horizontal scroll (swipe/trackpad) stays usable;
   auto-scroll pauses on hover, touch and keyboard focus, stops off-screen, and is disabled for prefers-reduced-motion. */
if (!customElements.get('tt-reviews-marquee')) {
  customElements.define('tt-reviews-marquee', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.tt-revs__scroller');
      this.track = this.querySelector('[data-track]');
      if (!this.scroller || !this.track) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = parseFloat(this.dataset.speed) || 28;
      this.onMotion = () => (this.motion.matches ? this.stop() : this.start());
      if (this.motion.addEventListener) this.motion.addEventListener('change', this.onMotion);
      this.onMotion();
    }
    disconnectedCallback() { this.stop(); }
    pad() { return parseFloat(getComputedStyle(this.scroller).paddingLeft) || 0; }
    start() {
      if (this.running) return;
      const dups = this.track.querySelectorAll('[data-dup]');
      if (!dups.length) return this.classList.add('is-static');
      dups.forEach((el) => el.removeAttribute('hidden'));
      this.classList.remove('is-static');
      this.classList.add('is-moving');
      this.running = true; this.paused = false; this.visible = true; this.last = null;
      this.pos = this.scroller.scrollLeft;
      const pause = () => { clearTimeout(this.resumeTimer); this.paused = true; };
      const resumeSoon = (ms) => { clearTimeout(this.resumeTimer); this.resumeTimer = setTimeout(() => { this.paused = false; this.last = null; }, ms); };
      this.handlers = [
        ['mouseenter', pause], ['mouseleave', () => resumeSoon(150)],
        ['touchstart', pause], ['touchend', () => resumeSoon(2500)], ['touchcancel', () => resumeSoon(2500)],
        ['focusin', pause], ['focusout', () => resumeSoon(300)],
      ];
      this.handlers.forEach(([e, fn]) => this.scroller.addEventListener(e, fn, { passive: true }));
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; this.last = null; }, { rootMargin: '100px' });
        this.io.observe(this);
      }
      const step = (t) => {
        if (!this.running) return;
        if (this.visible && !this.paused && !document.hidden) {
          if (this.last !== null) {
            const dt = Math.min(t - this.last, 100) / 1000;
            if (Math.abs(this.scroller.scrollLeft - this.pos) > 3) this.pos = this.scroller.scrollLeft; // user swiped
            const half = this.track.offsetWidth / 2, pad = this.pad();
            this.pos += this.speed * dt;
            if (half > 0 && this.pos >= half + pad) this.pos -= half; // identical view one copy earlier
            this.scroller.scrollLeft = this.pos;
          }
          this.last = t;
        } else {
          this.last = null;
          const half = this.track.offsetWidth / 2;
          if (half > 0 && this.scroller.scrollLeft >= half + this.pad()) { this.scroller.scrollLeft -= half; this.pos = this.scroller.scrollLeft; }
        }
        this.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }
    stop() {
      this.running = false;
      cancelAnimationFrame(this.raf);
      clearTimeout(this.resumeTimer);
      if (this.io) this.io.disconnect();
      (this.handlers || []).forEach(([e, fn]) => this.scroller.removeEventListener(e, fn));
      this.handlers = [];
      this.track.querySelectorAll('[data-dup]').forEach((el) => el.setAttribute('hidden', ''));
      this.classList.remove('is-moving');
      this.classList.add('is-static');
      this.scroller.scrollLeft = 0;
    }
  });
}
